import { jsx as _jsx } from "react/jsx-runtime";
import { PropertyLine } from "./propertyLine";
import { SyncedSliderInput } from "../../primitives/syncedSlider";
import { forwardRef } from "react";
import { makeStyles, mergeClasses } from "@fluentui/react-components";
import { UniformWidthStyling } from "../../primitives/utils";
const useStyles = makeStyles({
    uniformWidth: {
        ...UniformWidthStyling,
    },
});
/**
 * Renders a simple wrapper around the SyncedSliderInput
 * @param props
 * @returns
 */
export const SyncedSliderPropertyLine = forwardRef((props, ref) => {
    SyncedSliderPropertyLine.displayName = "SyncedSliderPropertyLine";
    const classes = useStyles();
    const { label, description, ...sliderProps } = props;
    return (_jsx(PropertyLine, { ref: ref, ...props, children: _jsx(SyncedSliderInput, { ...sliderProps, className: mergeClasses(classes.uniformWidth, props.className) }) }));
});
//# sourceMappingURL=syncedSliderPropertyLine.js.map